// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: none;
  z-index: 5000;
}
.react-modal-overlay .react-modal {
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 0.1rem solid #c0c0c0;
  background: white;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  color: #292727 !important;
}
@media (max-width: 768px) {
  .react-modal-overlay .react-modal {
    position: fixed;
  }
}
@media (min-width: 768px) {
  .react-modal-overlay .react-modal {
    padding: 2rem;
    top: 10%;
    left: 10%;
    right: 10%;
    bottom: 10%;
  }
}
.react-modal-overlay .react-modal button.react-modal-close {
  font-size: 1.2rem;
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
  text-align: center;
  background: none;
  border: none;
  padding: 0;
}
@media (max-width: 768px) {
  .react-modal-overlay .react-modal button.react-modal-close {
    font-size: 1.6rem;
    padding: 0.8rem;
    height: 3rem;
  }
}
.react-modal-overlay .react-modal .modal-top-buttons {
  right: 0;
  left: 0;
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1.5rem 0;
}
@media (max-width: 768px) {
  .react-modal-overlay .react-modal .modal-top-buttons {
    margin: 0 1rem;
  }
}
.react-modal-overlay .react-modal .react-modal-content {
  margin-top: 0;
  color: #292727;
}
@media (min-width: 768px) {
  .react-modal-overlay .react-modal .react-modal-content {
    margin-top: 0;
  }
}
.react-modal-overlay .react-modal.full-screen {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.react-modal-overlay.fade-overlay {
  background-color: rgba(0, 0, 0, 0.8);
}
.react-modal-overlay.fade-overlay .react-modal {
  border: none;
  color: white !important;
  background: none;
}
.react-modal-overlay.fade-overlay .react-modal .react-modal-content {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Modal/Modal.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,aCwBkB;ADtBpB;AADE;EACE,cC6BgB;ED5BhB,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,aAAA;EACA,yBAAA;AAGJ;AAFI;EAbF;IAcI,eAAA;EAKJ;AACF;AAJI;EAhBF;IAiBI,aAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;EAOJ;AACF;AANI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAQN;AANM;EAVF;IAWI,iBAAA;IACA,eAAA;IACA,YAAA;EASN;AACF;AAPI;EACE,QAAA;EACA,OAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AASN;AAPM;EARF;IASI,cAAA;EAUN;AACF;AARI;EACE,aAAA;EACA,cD9DM;ACwEZ;AATM;EAHF;IAII,aAAA;EAYN;AACF;AATE;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAWJ;;AAPA;EACE,oCAAA;AAUF;AATE;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;AAWJ;AAVI;EACE,YAAA;AAYN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import './Variables.scss';\n@import './Colors.scss';\n\n.react-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: none;\n  z-index: $modalOverlayLayer;\n  .react-modal {\n    z-index: $modalContentLayer;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 0.1rem solid $borderColor;\n    background: white;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    outline: none;\n    color: $textColor !important;\n    @media (max-width: $tablet) {\n      position: fixed;\n    }\n    @media (min-width: $tablet) {\n      padding: 2rem;\n      top: 10%;\n      left: 10%;\n      right: 10%;\n      bottom: 10%;\n    }\n    button.react-modal-close {\n      font-size: 1.2rem;\n      cursor: pointer;\n      height: 1.5rem;\n      width: 1.5rem;\n      text-align: center;\n      background: none;\n      border: none;\n      padding: 0;\n\n      @media (max-width: $tablet) {\n        font-size: 1.6rem;\n        padding: 0.8rem;\n        height: 3rem;\n      }\n    }\n    .modal-top-buttons {\n      right: 0;\n      left: 0;\n      position: relative;\n      display: flex;\n      justify-content: flex-end;\n      margin: 1rem 1.5rem 0;\n\n      @media (max-width: $tablet) {\n        margin: 0 1rem;\n      }\n    }\n    .react-modal-content {\n      margin-top: 0;\n      color: $textColor;\n      @media (min-width: $tablet) {\n        margin-top: 0;\n      }\n    }\n  }\n  .react-modal.full-screen {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n}\n\n.react-modal-overlay.fade-overlay {\n  background-color: rgba(0, 0, 0, 0.8);\n  .react-modal {\n    border: none;\n    color: white !important;\n    background: none;\n    .react-modal-content {\n      color: white;\n    }\n  }\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
